// Legacy translation packs use the shared platform brand in display text.
// Preserve URLs verbatim: the shared SpeakPal CDN also serves this product.
export function localizeBrandText(text) {
  return String(text).replace(
    /(?:https?:)?\/\/[^\s<>"']+|\b(?:[\w-]+\.)+speakpal\.ai(?:\/[^\s<>"']*)?|(\bSpeak\s?Pal(?:\.ai|\s+AI)?\b)/gi,
    (value, brand) => !brand ? value : /\.ai$/i.test(brand) ? 'JapanesePal.com' : 'JapanesePal'
  )
}
